import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Merges class names, with later Tailwind utilities winning over earlier ones of
 * the same kind. Without the merge, a `className` passed into a component is
 * appended and loses to whatever the component declared, which makes every widget
 * un-overridable in exactly the case someone needs to override it.
 *
 * The type scale uses `text-*` names (`text-body`, `text-page-title`, …) just like
 * colours (`text-on-brand`, `text-fg`). Default `tailwind-merge` treats every
 * `text-*` as one group, so `text-body` on a button silently dropped `text-on-brand`
 * and left dark label text on a brand fill. The scale is registered as font-size
 * so size and colour can coexist.
 */

const TYPE_SCALE = [
  'overline',
  'caption',
  'body-sm',
  'body',
  'card-title',
  'section-title',
  'page-title',
  'display',
  'kiosk-body',
  'kiosk-title',
  'kiosk-display',
] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...TYPE_SCALE] }],
    },
  },
});

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
